import React, { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import Blog from "../elements/Blog";
import Pagetitle from "../elements/Pagetitle";
import axios from "axios";
import BlogDetails from "../../pages/BlogDetails";
import { getStrapiURL } from "../../lib/api";

function Blogs() {

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allBlogs, setAllBlogs] = useState(null);
  
  useEffect(() => {
    const fetchBlogData = async () => {
      setLoading(true);
      try {
        let url = getStrapiURL("/api/articles?populate=*");
        const res = await axios.get(url);
        console.log("data fetched bloglist", res.data.data);
        setAllBlogs(res.data.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchBlogData();
  }, []);

  return (
    <section id="blog">
      <div className="container">
        <Pagetitle title="Derniers posts" />
        <div className="row blog-wrapper">
          {allBlogs?.slice(0,3)?.map((blogItem, index) => (
            <div className="col-md-4" key={blogItem?.id}>
              <Blog blogData={blogItem?.attributes} id={blogItem?.id} />
            </div>
          ))}
        </div>
        <div className="text-center">
          <div className="spacer" data-height="30"></div>
          <Link to="/blog" className="btn btn-default btn-lg" >
            Voir le blog
          </Link>
        </div>
      </div>
      <Routes>
        <Route path=":id/:title" element={<BlogDetails />} />
      </Routes>
    </section>
  );
}

export default Blogs;
